module.exports = __webpack_public_path__ + "img/101.español.1a11709a.svg";